export default __webpack_public_path__ + "static/media/logo_unl.69ceacf6.svg";